import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { client } from "../data/client";
import { urlFor } from '../data/urlFor';
import { Icon } from "@iconify/react"; // check out https://icon-sets.iconify.design/ for icon list
import '../styles/retro.scss';
import usePageTitle from '../hooks/usePageTitle';
import StandardLink from "../tools/StandardLink"

export default function Theme() {
  const { slug } = useParams();
  const [theme, setTheme] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const query = `*[_type == "theme" && slug.current == $slug][0]{
          name,
          description,
          theme_react_icon,
          icebreaker,
          like,
          dislike,
          blocker,
          background,
          font_color,
          main_image
        }`;

      const data = await client.fetch(query, { slug });
        setTheme(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching theme:', err);
        setLoading(false);
      }
    };

    fetchTheme();
  }, [slug]);
  
  usePageTitle("Retro Theme | Dochano")

  if (loading) return <p id="Retro">Loading...</p>;
  if (!theme) return <p id="Retro">Theme not found.</p>;

  const themeStyle = {
    background: theme.background ?? 'transparent',
    color: theme.font_color ?? '#000'
  };

  return (
    <section>
      <p className="indent"><Link to="../retrospectives">Retrospectives</Link> | <Link to="../retrotime">Retrospective Grouping by Dates/Seasons</Link> </p>

      <div id="Theme" style={themeStyle}>
        <div className="flex">
          {theme.main_image && <img src={urlFor(theme.main_image).url()} alt={`${theme.name}`} className="mainImage" />}
          <div className="theme-text">
            <h1>{(theme.theme_react_icon && <Icon icon={theme.theme_react_icon} />)}{theme.name}</h1>
            <p>{theme.description}</p>
          </div>
        </div>
        
        
        <p><strong>Icebreaker:</strong> {theme.icebreaker}</p>
        <div className="sticky-note">
          <h3>Example</h3>
          <p>Normally this would be filled out by a team member.</p>
        </div>

        <div className="flex">
          <div className="flexing">
            <p><strong>Like:</strong> {theme.like}</p>

            <div className="sticky-note even">
              <h3>Coming soon...</h3>
              <p>More updates coming soon...</p>
            </div>

          </div>
          <div className="flexing">
            <p><strong>Dislike:</strong> {theme.dislike}</p>

            <div className="sticky-note">
              <h3>Images</h3>
              <p>Adding images for each Retro using Sanity.io is next up.</p>
            </div>

            <div className="sticky-note even">
              <h3>Loren Ipsum</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum pharetra sagittis lectus.</p>
            </div>

          </div>
        </div>

        <p><strong>Blocker:</strong> {theme.blocker}</p>

        <div className="sticky-note">
          <h3>Loren Ipsum Generator</h3>
          <p><StandardLink href="https://www.lipsum.com/">Click here to check it out.</StandardLink></p>
        </div>
        
      </div>
    </section>
  );
}
